
const months = [
  { id: 0, name: 'January', abbr: 'Jan' },
  { id: 1, name: 'February', abbr: 'Feb' },
  { id: 2, name: 'March', abbr: 'Mar' },
  { id: 3, name: 'April', abbr: 'Apr' },
  { id: 4, name: 'May', abbr: 'May' },
  { id: 5, name: 'June', abbr: 'Jun' },
  { id: 6, name: 'July', abbr: 'Jul' },
  { id: 7, name: 'August', abbr: 'Aug' },
  { id: 8, name: 'September', abbr: 'Sep' },
  { id: 9, name: 'October', abbr: 'Oct' },
  { id: 10, name: 'November', abbr: 'Nov' },
  { id: 11, name: 'December', abbr: 'Dec' },
]

export default months
